import type { TMessages } from '@/types/TMessages'

export const messages = {
  submitButton: 'Отправить',
} as const satisfies TMessages
